import { Timestamp } from '@griply/types';
import { format, isSameYear } from 'date-fns';

import { TranslateFunction } from './get-task-due-date';

export type GetStartTillEndLabelOptions = {
  startDate?: Timestamp;
  endDate?: Timestamp;
  isShort?: boolean;
  today: Timestamp;
  t: TranslateFunction;
  dateFormat?: string;
};

export const getStartTillEndLabel = ({
  startDate,
  endDate,
  isShort,
  today,
  t,
  dateFormat,
}: GetStartTillEndLabelOptions) => {
  const isMonthFirst = dateFormat?.toLowerCase().startsWith('m');
  const dayAndMonthFormat = isMonthFirst ? 'MMM d' : 'd MMM';
  const fullDateFormat = isMonthFirst
    ? `MMM d${isShort ? " ''yy" : ' yyyy'}`
    : `d MMM${isShort ? " ''yy" : ' yyyy'}`;

  const fallbackStartLabel = isShort
    ? undefined
    : t('general.labels.no-start-date');
  const startLabel = startDate
    ? format(
        startDate,
        isSameYear(today, startDate) ? dayAndMonthFormat : fullDateFormat,
      )
    : fallbackStartLabel;

  const fallbackEndLabel = isShort
    ? undefined
    : t('general.labels.no-deadline');
  const endLabel = endDate
    ? format(
        endDate,
        isSameYear(today, endDate) ? dayAndMonthFormat : fullDateFormat,
      )
    : fallbackEndLabel;

  if (!startDate && !endDate) {
    return t('general.labels.no-schedule');
  }

  if (
    startDate &&
    endDate &&
    isSameYear(startDate, endDate) &&
    isSameYear(today, startDate) &&
    format(startDate, 'M') === format(endDate, 'M')
  ) {
    if (isMonthFirst) {
      return `${format(startDate, 'MMM d')}-${format(endDate, 'd')}`;
    }
    return `${format(startDate, 'd')}-${format(endDate, 'd MMM')}`;
  }

  return [startLabel, endLabel].filter(Boolean).join(' - ');
};
